(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["baddie-entry-portal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('baddie-entry-portal')) {
    customElements.define('baddie-entry-portal', class extends HTMLElement {
      connectedCallback() {
        const forcePreview = new URLSearchParams(window.location.search).has('portal_preview');
        const alreadySeen = window.sessionStorage.getItem('baddie-glam-entry-seen') === '1';

        if (alreadySeen && !forcePreview && !window.Shopify?.designMode) {
          this.remove();
          return;
        }

        this.trigger = this.querySelector('[data-baddie-entry-trigger]');
        this.video = this.querySelector('[data-baddie-entry-video]');
        this.hint = this.querySelector('[data-baddie-entry-hint]');
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        this.triggerBounds = mobile
          ? { x: 74, y: 1218, width: 920, height: 380, videoWidth: 1080, videoHeight: 1920 }
          : { x: 436, y: 684, width: 1004, height: 256, videoWidth: 1920, videoHeight: 1080 };

        if (this.video) {
          this.video.poster = mobile ? this.video.dataset.mobilePoster : this.video.dataset.desktopPoster;
          this.video.src = mobile ? this.video.dataset.mobileSrc : this.video.dataset.desktopSrc;
          this.video.addEventListener('loadeddata', () => this.primeVideo(), { once: true });
          this.video.addEventListener('loadedmetadata', () => this.updateTriggerBounds(), { once: true });
          this.video.addEventListener('error', () => this.finish(), { once: true });
          this.video.load();
        }

        this.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        this.trigger?.addEventListener('click', () => this.enter(), { once: true });
        document.addEventListener('keydown', this.handleKeydown);
        window.addEventListener('resize', this.updateTriggerBounds);
        this.updateTriggerBounds();

        if (this.video?.readyState >= 2) this.primeVideo();
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.handleKeydown);
        window.removeEventListener('resize', this.updateTriggerBounds);
      }

      handleKeydown = (event) => {
        if (event.key === 'Escape') this.finish();
      };

      updateTriggerBounds = () => {
        if (!this.trigger || !this.triggerBounds) return;

        const bounds = this.triggerBounds;
        const scale = Math.max(window.innerWidth / bounds.videoWidth, window.innerHeight / bounds.videoHeight);
        const renderedWidth = bounds.videoWidth * scale;
        const renderedHeight = bounds.videoHeight * scale;
        const offsetX = (window.innerWidth - renderedWidth) / 2;
        const offsetY = (window.innerHeight - renderedHeight) / 2;

        this.trigger.style.left = `${offsetX + bounds.x * scale}px`;
        this.trigger.style.top = `${offsetY + bounds.y * scale}px`;
        this.trigger.style.bottom = 'auto';
        this.trigger.style.width = `${bounds.width * scale}px`;
        this.trigger.style.height = `${bounds.height * scale}px`;
        this.trigger.style.transform = 'none';
      };

      primeVideo() {
        if (!this.video || this.classList.contains('is-ready')) return;

        const reveal = () => {
          if (this.classList.contains('is-ready')) return;
          this.video.pause();
          this.video.removeAttribute('poster');
          this.classList.add('is-ready');
          this.trigger.disabled = false;
          this.hint.textContent = 'PRESIONA PARA ENTRAR';
          requestAnimationFrame(() => this.trigger?.focus({ preventScroll: true }));
        };

        if (this.video.seekable.length > 0) {
          this.video.addEventListener('seeked', reveal, { once: true });
          this.video.currentTime = 0.001;
          window.setTimeout(reveal, 700);
          return;
        }

        reveal();
      }

      enter() {
        if (!this.classList.contains('is-ready') || this.classList.contains('is-playing')) return;
        this.classList.add('is-playing');

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.finish();
          return;
        }

        const video = this.video;

        if (!video) {
          this.finish();
          return;
        }

        video.addEventListener('ended', () => this.finish(), { once: true });
        video.play().catch(() => this.finish());
        window.setTimeout(() => this.finish(), 6200);
      }

      finish() {
        if (this.classList.contains('is-exiting')) return;
        window.sessionStorage.setItem('baddie-glam-entry-seen', '1');
        this.classList.add('is-exiting');
        document.documentElement.style.overflow = '';
        window.setTimeout(() => this.remove(), 600);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
